module.exports = __webpack_public_path__ + "media/images/design/images/icons/facebook-blue-e4da23704f27c9df07e6c21a13e28bfd.png";